import { get, post, put, deleteRequest, postExport } from "./index";

export const getNDRs = async (query, toast) => {
  return post("/ndr/listing", { ...query }, undefined, toast);
};

export const createNDR = async (data, toast) => {
  return post("/ndr/", data, undefined, toast);
};

export const updateNDR = async (id, payload, toast) => {
  return put(`/ndr/${id}`, { payload }, undefined, toast);
};

export const deleteNDR = async (id, toast) => {
  return deleteRequest(`/ndr/${id}`, undefined, toast);
};

export const getNDRExport = async (query, toast) => {
  return postExport("/ndr/export", { ...query }, undefined, toast);
};
